import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/cfg/commission/stage/list`,
    method: "get",
  });
}
// 查询阶段分佣配置
export function getJDConfig(shareStageId) {
  return request.send({
    url: `/pmy/sys/cfg/commission?shareStageId=${shareStageId}`,
    method: "get",
  });
}
// 平台订单分佣规则设置
export function setZydConfig(data) {
  return request.send({
    url: `/pmy/sys/cfg/commission/pmy`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 三方订单分佣规则设置
export function setLxConfig(data) {
  return request.send({
    url: `/pmy/sys/cfg/commission/lx`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 销售渠道（机构）返佣规则设置
export function setRebateCompanyConfig(data) {
  return request.send({
    url: `/pmy/sys/cfg/commission/rebate/company`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 销售渠道（司机）返佣规则设置
export function setRebateDriverConfig(data) {
  return request.send({
    url: `/pmy/sys/cfg/commission/rebate/driver`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
